export const ActionTypes = {
    SET_COMPANY: 'company/SET_COMPANY',
    SET_LOADING_COMPANY: 'company/SET_LOADING_COMPANY',
    SET_COMPANY_NOT_FOUND: 'company/SET_COMPANY_NOT_FOUND',
    SET_COMPANIES: 'company/SET_COMPANIES',
    ADD_COMPANIES: 'company/ADD_COMPANIES',
    SET_LOADING_COMPANIES: 'company/SET_LOADING_COMPANIES',
}